import { render } from "./sintomas.vue?vue&type=template&id=9126a984&scoped=true"
import script from "./sintomas.vue?vue&type=script&lang=js"
export * from "./sintomas.vue?vue&type=script&lang=js"

import "./sintomas.vue?vue&type=style&index=0&id=9126a984&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-9126a984"

export default script